import {useGetRelatedContacts} from '../graphql/hooks/use-get-related-contacts';

export function useGetRelatedContactsCount(accountId: string): string | undefined {
    const {contacts} = useGetRelatedContacts(accountId, false, false, null, null);

    return contacts && contacts.totalCount ? `${contacts.totalCount}` : undefined;
}
